import { PhoneInputValue } from "../types";

export const inputValueToPhoneString = (value: PhoneInputValue) =>
  `${value.code}${value.phone}`;
